const INIT_APP = "app::init";

export { INIT_APP };
